export const roundNames = {
  1: ['Championship'],
  2: ['Final 4', 'Championship'],
  3: ['Elite 8', 'Final 4', 'Championship'],
  4: ['Sweet 16', 'Elite 8', 'Final 4', 'Championship']
};